import { useParams } from "react-router-dom";
import useUsers from "../hooks/use-users";
import UsersPage from "../components/users-page";
import useBrandName from "../hooks/use-brand-name";

const UsersRoute: React.FC = () => {
  const { brandId } = useParams<{ brandId: string }>();
  const brandName = useBrandName(brandId);
  const { users, isLoading } = useUsers({ brandId, accountType: "app" });
  const title = `Users for ${brandName}`;

  return (
    <UsersPage
      title={title}
      brandName={brandName}
      type="app"
      users={users}
      isLoadingUsers={isLoading}
      brandId={brandId}
    />
  );
};

export default UsersRoute;
